import { render, staticRenderFns } from "./DyAvatarGenerator.vue?vue&type=template&id=2673680c&"
import script from "./DyAvatarGenerator.vue?vue&type=script&lang=js&"
export * from "./DyAvatarGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports